import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConnectedDotsIconWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1244_8661)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 4.28571C10.5503 4.28571 9.375 5.46096 9.375 6.91071C9.375 8.36045 10.5503 9.53571 12 9.53571C13.4497 9.53571 14.625 8.36045 14.625 6.91071C14.625 5.46096 13.4497 4.28571 12 4.28571Z",
				stroke: "#ffffff",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.375 15C4.92525 15 3.75 16.1753 3.75 17.625C3.75 19.0747 4.92525 20.25 6.375 20.25C7.82475 20.25 9 19.0747 9 17.625C9 16.1753 7.82475 15 6.375 15Z",
				stroke: "#ffffff",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.625 15C16.1753 15 15 16.1753 15 17.625C15 19.0747 16.1753 20.25 17.625 20.25C19.0747 20.25 20.25 19.0747 20.25 17.625C20.25 16.1753 19.0747 15 17.625 15Z",
				stroke: "#ffffff",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9999 12.8572L11.9999 9.85716M11.9999 12.8572L16.2856 15.4286M11.9999 12.8572L8.14279 15.4286",
				stroke: "#ffffff",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1244_8661",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(24 24) rotate(-180)"
		})
	}) })]
});
export default SvgConnectedDotsIconWhite;
